<template>
  <div>
    <v-container
      fluid
      class="pa-0 info-drawer"
    >
      <div class="pa-6">
        <h2 class="d-flex justify-space-between align center mb-1">
          Manage Integration with Carts
          <v-btn
            icon
            @click.stop="$store.commit('ui/drawer.right.toggle')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h2>
        <v-btn
        class = "mt-2"
          outlined
          :loading="loading"
          @click.stop="updateCarts"
        >
          SAVE
        </v-btn>
      </div>

          <v-text-field
            v-model="searchString"
            outlined
            class="pa-6 py-0 text--grey"
            label="Search"
            prepend-inner-icon="search"
          />
          <div class="pa-6 pt-0 list-frame">
            <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5 mb-5">
                <span class="white">  Selected ({{ filterItems(cartList).length }})</span>
              </div>
              <div class = "strike-not-through grey--text text--darken-2 text-left pl-5 py-5"
              v-if ="!cartList.length">No Cart Selected</div>
              <v-list-item-group
                multiple
              >
                <v-list-item
                  v-for="list in filterItems(cartList)"
                  :key="list.id"
                  :ripple="false"
                  class="pa-0 mt-n4"
                >
                  <template v-slot:default="{ }">
                    <v-list-item-action class="mr-2 align-self-start">
                      <v-icon
                        color="#03B6FC"
                        @click="selectCart(list, false)"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title class = "mb-5">{{ list.name }}</v-list-item-title>
                      <v-text-field label = "Item/Product Ids" outlined hint = "Please input comma separated Items/Product Ids" v-model = "list.item_id"></v-text-field>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>

           <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5 mb-5">
                <span class="white">  Unselected ({{ filterItems(allCarts).length }})</span>
              </div>
              <div class = "strike-not-through grey--text text--darken-2 text-left pl-5 py-5"
              v-if ="!filterItems(allCarts).length">No Cart Available</div>
              <v-list-item-group>
                <v-list-item
                  v-for="list in filterItems(allCarts)"
                  :key="list.id"
                  class="pa-0 mt-n4"
                  :ripple="false"
                >
                  <template>
                    <v-list-item-action
                      class="mr-2 align-self-start"
                    >
                      <v-icon
                        color="grey"
                        @click="selectCart(list, true)"
                      >
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title class = "mb-5">{{ list.name }}</v-list-item-title>
                      <v-text-field label = "Item/Product Ids" outlined v-model = "list.item_id" hint = "Please input comma separated Items/Product Ids"></v-text-field>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
    </v-container>
  </div>
</template>
  <script>
  import commonFunctions from '@/commonFunctions'
  import { $lists } from '@/services'

  export default {
    data () {
      return {
        listId: null,
        allSelected: false,
        currentPage: 1,
        defaultValueTrue: true,
        defaultValueFalse: false,
        loading: false,
        totalListCount: 0,
        totalListCountStatic: 0,
        searchString: '',
        cartList: [],
        allCarts: [],
      }
    },
    mounted () {
      this.listId = this.$route.params.listId
      this.getCartsList()
    },
    methods: {
      getCartsList () {
        this.loading = true
        $lists.getCartsList(this.listId).then(response => {
          this.cartList = response.data.data
          this.getCarts()
        }).catch(error => {
          console.error('Error', error)
        })
      },
      filterItems (presets) {
        return presets.filter(preset => {
          const regex = new RegExp('(' + this.searchString + ')', 'i')
          return preset.name.match(regex)
        })
      },
      selectCart (list, add) {
        let index
        if (add) {
          index = this.allCarts.findIndex(x => x.id === list.id)
          this.cartList.push(
            ...this.allCarts.splice(
              index < 0 ? 0 : index,
              index < 0 ? this.allCarts.length : 1,
            ),
          )
        } else {
          index = this.cartList.findIndex(x => x.id === list.id)
          if (index < 0) {
            this.cartList = []
            this.currentPage = 1
          } else {
            this.allCarts.unshift(...this.cartList.splice(index, 1))
          }
        }
        if (index < 0) this.getCarts(add)
      },
      updateCarts () {
        this.loading = true
        $lists.updateCarts(this.listId, {
            selected_carts: this.cartList.map(x => {
                return { id : x.id,item_ids : x.item_id }
            }),
            unselected_carts: this.allCarts.map(x => {
                return x.id
            })
        }).then(response => {
          this.$store.commit('ui/snackbar', { message: 'Changes has been saved', type: 'success' })
          this.$store.commit('ui/drawer.right', {
            show: false,
            component: null,
            response: { cartList: JSON.parse(JSON.stringify(this.cartList)) },
          })
        }).catch(error => {
          console.error('Error', error)
        }).finally(() => {
          this.loading = false
        })
      },
      getCarts (showMore) {
        this.loading = true
        $lists.getCarts().then(response => {
          if (!this.searchString) { this.totalListCountStatic = response.data.data.length}
          this.totalListCount = response.data.data.length
          // filter for common data
          this.cartList.map(cartList => {
            response.data.data.map((cart, index) => {
              if (cartList.id === cart.id) {
                response.data.data.splice(index, 1)
              }
            })
          })
         this.allCarts = response.data.data
        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })
      },
    },
  }

  </script>
